'use client';

import React, { createContext, useContext, useState, type ReactNode } from 'react';

interface BuyA1XModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const BuyA1XModalContext = createContext<BuyA1XModalContextType | undefined>(undefined);

interface BuyA1XModalProviderProps {
  children: ReactNode;
}

export const BuyA1XModalProvider = ({ children }: BuyA1XModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const value = {
    isOpen,
    openModal,
    closeModal,
  };

  return (
    <BuyA1XModalContext.Provider value={value}>
      {children}
    </BuyA1XModalContext.Provider>
  );
};

export const useBuyA1XModal = () => {
  const context = useContext(BuyA1XModalContext);
  if (context === undefined) {
    throw new Error('useBuyA1XModal must be used within a BuyA1XModalProvider');
  }
  return context;
};